module.exports = __webpack_public_path__ + "static/media/display12.8f4ab9a2.jpg";